/**
 * Copyright IBM Corp. 2016, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { Settings } from '@carbon/icons-react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import React__default from 'react';
import { usePrefix } from '../../internal/usePrefix.js';
import OverflowMenu from '../OverflowMenu/index.js';

const defaultIconDescription = 'Settings';
const TableToolbarMenu = _ref => {
  let {
    className,
    renderIcon = Settings,
    iconDescription = defaultIconDescription,
    children,
    menuOptionsClass,
    ...rest
  } = _ref;
  const prefix = usePrefix();
  const toolbarActionClasses = cx(className, `${prefix}--toolbar-action ${prefix}--overflow-menu`);
  const menuOptionsClasses = cx(menuOptionsClass, `${prefix}--toolbar-action__menu`);
  return /*#__PURE__*/React__default.createElement(OverflowMenu, _extends({
    "aria-label": iconDescription,
    renderIcon: renderIcon,
    className: toolbarActionClasses,
    title: iconDescription,
    iconDescription: iconDescription,
    menuOptionsClass: menuOptionsClasses,
    flipped: true
  }, rest), children);
};
TableToolbarMenu.propTypes = {
  children: PropTypes.node.isRequired,
  /**
   * Provide an optional class name for the toolbar menu
   */
  className: PropTypes.string,
  /**
   * The description of the menu icon.
   */
  iconDescription: PropTypes.string,
  /**
   * Provide an optional class name for the toolbar menu
   */
  menuOptionsClass: PropTypes.string,
  /**
   * Optional prop to allow overriding the default menu icon
   */
  renderIcon: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
};

export { TableToolbarMenu as default };
